import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withModifiers as _withModifiers, mergeProps as _mergeProps, withDirectives as _withDirectives, Transition as _Transition, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onPointerdown"]
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-container" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" default header ")
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" default body ")
const _hoisted_8 = { class: "modal-footer" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "modal-default-flex-grow" }, null, -1)

import { FeatureNode } from "game/layers";
import { computed, ref, toRefs } from "vue";
import Context from "./Context.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: "update:modelValue", value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const _props = __props as {
    modelValue: boolean;
}


const props = toRefs(_props);


const isOpen = computed(() => props.modelValue || isAnimating.value);
function close() {
    emit("update:modelValue", false);
}

const isAnimating = ref(false);

const contextRef = ref<typeof Context | null>(null);
const nodes = computed<Record<string, FeatureNode | undefined> | null>(
    () => contextRef.value?.nodes ?? null
);

expose({ isOpen, nodes });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "#modal-root" }, [
    _createVNode(_Transition, {
      name: "modal",
      onBeforeEnter: _cache[0] || (_cache[0] = ($event: any) => (isAnimating.value = true)),
      onAfterLeave: _cache[1] || (_cache[1] = ($event: any) => (isAnimating.value = false))
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _mergeProps({
          class: "modal-mask",
          onPointerdown: _withModifiers(close, ["self"])
        }, _ctx.$attrs), [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _renderSlot(_ctx.$slots, "header", { shown: _unref(isOpen) }, () => [
                  _hoisted_5
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(Context, {
                  ref_key: "contextRef",
                  ref: contextRef
                }, {
                  default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "body", { shown: _unref(isOpen) }, () => [
                      _hoisted_7
                    ])
                  ]),
                  _: 3
                }, 512)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _renderSlot(_ctx.$slots, "footer", { shown: _unref(isOpen) }, () => [
                  _createElementVNode("div", { class: "modal-default-footer" }, [
                    _hoisted_9,
                    _createElementVNode("button", {
                      class: "button modal-default-button",
                      onClick: close
                    }, " Close ")
                  ])
                ])
              ])
            ])
          ])
        ], 16, _hoisted_1), [
          [_vShow, __props.modelValue]
        ])
      ]),
      _: 3
    })
  ]))
}
}

})